import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListAgent = createAsyncThunk(
  "AgentNameList/fetchListAgent",
  async (cmpdetail, { rejectWithValue }) => {

    try {
      const result = await GET(`/broker/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const AgentNameListSlice = createSlice({
  name: "AgentNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListAgent.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListAgent.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListAgent.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default AgentNameListSlice.reducer;
